import { AttributeOptionModel } from '../domain/models/category.model';

export function attributeOptionsToBaseOptions(
  attributeOptions: AttributeOptionModel<any>[]
) {
  return attributeOptions.map((option) => ({
    label: option.value,
    value: option.id,
  }));
}
